
function ScrollController(element, selector) {
  this.element = element;
  this.selector = selector;
  this.clientY = null;
}

ScrollController.prototype = {
  /**
   * Prevent default unless within _selector
   * @param  event object event
   * @return void
   */
  preventScroll(event) {
    if (this.element === false || !event.target.closest(this.selector)) {
      event.preventDefault();
    }
  },
  /**
   * Cache the clientY co-ordinates for
   * comparison
   *
   * @param  event object event
   * @return void
   */
  captureClientY(event) {
    // only respond to a single touch
    if (event.targetTouches.length === 1) {
      this.clientY = event.targetTouches[0].clientY;
    }
  },
  /**
   * Detect whether the element is at the top
   * or the bottom of their scroll and prevent
   * the user from scrolling beyond
   *
   * @param  event object event
   * @return void
   */
  preventOverscroll(event) {
    // only respond to a single touch
    if (event.targetTouches.length !== 1) {
      return;
    }

    const e = this.element;
    const currentY = this.clientY;
    this.clientY = event.targetTouches[0].clientY - currentY;

    // The element at the top of its scroll,
    // and the user scrolls down
    if (e.scrollTop === 0 && this.clientY > 0) {
      event.preventDefault();
    }

    // The element at the bottom of its scroll,
    // and the user scrolls up
    // https://developer.mozilla.org/en-US/docs/Web/API/Element/scrollHeight#Problems_and_solutions
    if (e.scrollHeight - e.scrollTop <= e.clientHeight && this.clientY < 0) {
      event.preventDefault();
    }
  },
  enable() {
    this.element.addEventListener('touchstart', this.captureClientY, false);
    this.element.addEventListener('touchmove', this.preventOverscroll, false);
    document.body.addEventListener('touchmove', this.preventBodyScroll, false);
  },
  disable() {
    this.element.removeEventListener('touchstart', this.captureClientY, false);
    this.element.removeEventListener('touchmove', this.preventOverscroll, false);
    document.body.removeEventListener('touchmove', this.preventBodyScroll, false);
  },
};

export default ScrollController;



// WEBPACK FOOTER //
// ./ScrollController.js